import request from "@/axios.js";

/**
 * Scraping runs reported by the scraping VPS.
 * Backend: Rankwell_Dashboard_Backend_Server/routes/scraping
 */
export default class ScrapingRun {
	/**
	 * List runs, newest first.
	 * @param {Object} filters - {scraper, status, days, limit}
	 * @returns {Promise<Array>}
	 */
	static async list(filters = {}){
		const params = {};
		if(filters.scraper) params.scraper = filters.scraper;
		if(filters.status) params.status = filters.status;
		if(filters.days) params.days = filters.days;
		if(filters.limit) params.limit = filters.limit;
		const response = await request.get("scraping/runs", {params});
		return response.data;
	}

	/**
	 * Per-scraper totals over the last N days.
	 * @param {Number} days
	 * @returns {Promise<{days: Number, scrapers: Array}>}
	 */
	static async summary(days = 7){
		const response = await request.get("scraping/runs/summary", {params: {days}});
		return response.data;
	}

	/**
	 * Distinct scraper names, for the filter.
	 * @returns {Promise<Array<String>>}
	 */
	static async scrapers(){
		const response = await request.get("scraping/scrapers");
		return response.data;
	}
}
